import { graphicCreator } from "@visactor/vrender-core";

import { isValidNumber, merge } from "@visactor/vutils";

import { Tag } from "../tag";

import { Marker } from "./base";

import { DEFAULT_CARTESIAN_MARK_AREA_TEXT_STYLE_MAP, DEFAULT_MARK_AREA_THEME } from "./config";

import { limitShapeInBounds } from "../util/limit-shape";

import { loadMarkAreaComponent } from "./register";

import { DEFAULT_STATES } from "../constant";

import { DefaultExitMarkerAnimation, DefaultUpdateMarkAreaAnimation, markAreaAnimate } from "./animate/animate";

loadMarkAreaComponent();

export function registerMarkAreaAnimate() {
    MarkArea._animate = markAreaAnimate;
}

export class MarkArea extends Marker {
    markerAnimate(state) {
        MarkArea._animate && this._animationConfig && MarkArea._animate(this._area, this._label, this._animationConfig, state);
    }
    getArea() {
        return this._area;
    }
    getLabel() {
        return this._label;
    }
    constructor(attributes, options) {
        super((null == options ? void 0 : options.skipDefault) ? attributes : merge({}, MarkArea.defaultAttributes, attributes)), 
        this.name = "markArea", this.defaultUpdateAnimation = DefaultUpdateMarkAreaAnimation, 
        this.defaultExitAnimation = DefaultExitMarkerAnimation;
    }
    getPointAttrByPosition(position) {
        const {x1: x1, x2: x2, y1: y1, y2: y2} = this._area.AABBBounds;
        return position.includes("left") || position.includes("Left") ? {
            x: x1,
            y: (y1 + y2) / 2
        } : position.includes("right") || position.includes("Right") ? {
            x: x2,
            y: (y1 + y2) / 2
        } : position.includes("top") || position.includes("Top") ? {
            x: (x1 + x2) / 2,
            y: y1
        } : position.includes("bottom") || position.includes("Bottom") ? {
            x: (x1 + x2) / 2,
            y: y2
        } : {
            x: (x1 + x2) / 2,
            y: (y1 + y2) / 2
        };
    }
    setLabelPos() {
        var _a;
        if (this._label && this._area) {
            const {label: label = {}} = this.attribute, labelPosition = null !== (_a = label.position) && void 0 !== _a ? _a : "middle", labelPoint = this.getPointAttrByPosition(labelPosition);
            if (this._label.setAttributes(Object.assign(Object.assign({}, labelPoint), {
                textStyle: Object.assign(Object.assign({}, DEFAULT_CARTESIAN_MARK_AREA_TEXT_STYLE_MAP[labelPosition]), label.textStyle)
            })), this.attribute.limitRect && label.confine) {
                const {x: x, y: y, width: width, height: height} = this.attribute.limitRect;
                limitShapeInBounds(this._label, {
                    x1: x,
                    y1: y,
                    x2: x + width,
                    y2: y + height
                });
            }
        }
    }
    initMarker(container) {
        const {points: points, label: label, areaStyle: areaStyle, state: state} = this.attribute, area = graphicCreator.polygon(Object.assign({
            points: points
        }, areaStyle));
        area.states = merge({}, DEFAULT_STATES, null == state ? void 0 : state.area), area.name = "mark-area-polygon", 
        this._area = area, container.add(area);
        const markLabel = new Tag(Object.assign(Object.assign({}, label), {
            state: {
                panel: merge({}, DEFAULT_STATES, null == state ? void 0 : state.labelBackground),
                text: merge({}, DEFAULT_STATES, null == state ? void 0 : state.label)
            }
        }));
        markLabel.name = "mark-area-label", this._label = markLabel, container.add(markLabel), 
        this.setLabelPos();
    }
    updateMarker() {
        const {points: points, label: label, areaStyle: areaStyle, state: state} = this.attribute;
        this._area && (this._area.setAttributes(Object.assign({
            points: points
        }, areaStyle)), this._area.states = merge({}, DEFAULT_STATES, null == state ? void 0 : state.area)), 
        this._label && this._label.setAttributes(Object.assign(Object.assign({
            dx: 0,
            dy: 0
        }, label), {
            state: {
                panel: merge({}, DEFAULT_STATES, null == state ? void 0 : state.labelBackground),
                text: merge({}, DEFAULT_STATES, null == state ? void 0 : state.label)
            }
        })), this.setLabelPos();
    }
    isValidPoints() {
        const {points: points} = this.attribute;
        if (!points || points.length < 3) return !1;
        let validFlag = !0;
        return points.forEach((point => {
            isValidNumber(point.x) && isValidNumber(point.y) || (validFlag = !1);
        })), validFlag;
    }
}

MarkArea.defaultAttributes = DEFAULT_MARK_AREA_THEME;
//# sourceMappingURL=area.js.map
